import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import EmployeeDetails from "./EmployeeDetails";
import EmployeeSalary from "../salaries/index";
import EmployeeSchedule from "../schedules/index";
import EditSettingEmployee from "../settings/edit"
import CustomTabs from "components/tabs/customTab";

const EmployeeTab = ({ recordId }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const pathParts = location.pathname.split("/").filter(Boolean);
  const lastSegment = pathParts[pathParts.length - 1];
  const [activeTab, setActiveTab] = useState(lastSegment);

  const items = [
    { 
      value: "view", 
      label: "Details", 
      children: 
        <EmployeeDetails recordId={recordId} /> 
    },
    { 
      value: "employee-salaries", 
      label: "Salary", 
      children: 
        <EmployeeSalary employeeId={recordId} /> 
    },
    { 
      value: "schedules", 
      label: "Schedule List", 
      children: 
        <EmployeeSchedule employeeId={recordId} /> 
    },
    { 
      value: "settings", 
      label: "Settings", 
      children: 
        <EditSettingEmployee employeeId={recordId} /> 
    },
  ];

  const onChange = (value) => {
    setActiveTab(value);
    navigate(`/console/employees/${recordId}/${value}`);

  };

  return (
    <div>
      <CustomTabs
        tabs={items}
        activeTab={activeTab}
        onChange={onChange}
        height="h-10"
      />

      <div className="mt-6">
        {items.find(item => item.value === activeTab)?.children}
      </div>
    </div>
  );
};

export default EmployeeTab;
